import { Alert, AlertItem, Spinner } from '@vmware-react/clarity';
import React, { FC, useState } from 'react';
import { GroupPlaceholder } from 'vrlcm-gui-types';
import { Collapsible } from '../collapsible';

interface Props {
  group: GroupPlaceholder;
  initialCollapsed?: boolean;
}

const PrecheckGroupPlaceholder: FC<Props> = props => {
  const {
    group: { groupName, groupDescription },
    initialCollapsed
  } = props;

  const [collapsed, setColapsed] = useState(
    initialCollapsed !== undefined ? initialCollapsed : true
  );
  const onToggleCb = () => setColapsed(!collapsed);

  const title = (
    <span className="validation-group-header">
      <span>{groupName}</span>
      <span className="validation-group-header-labels">
        <Spinner size="sm" />
      </span>
    </span>
  );

  return (
    <Collapsible title={title} collapsed={collapsed} onToggle={onToggleCb}>
      <div className="validation-group-container">
        <Alert
          ariaLiveMsg={`${groupDescription}`}
          items={groupDescription.map((d, i) => (
            <AlertItem key={i}>{d}</AlertItem>
          ))}
        />
      </div>
    </Collapsible>
  );
};

export default PrecheckGroupPlaceholder;
